// Слияние живого батча в полотно матчей. Чистые функции — покрыты тестами на фикстурах.
import type { LiveRow, MatchRow, MatchesScreen } from './types';

/** Строки любого экрана: поле есть в батче → заменить (null = очистить), нет → оставить. Без изменений — тот же массив. */
export function mergeRows<T extends MatchRow>(rows: T[], live: LiveRow[]): T[] {
  if (!live.length) return rows;
  const byId = new Map(live.map((row) => [row.id, row]));
  let changed = false;
  const next = rows.map((row) => {
    const update = byId.get(row.id);
    if (!update) return row;
    changed = true;
    return { ...row, ...update };
  });
  return changed ? next : rows;
}

/** Есть «живая» у нас строка, которой нет в батче → матч закончился: экран перезапросить. */
export function rowsHaveStaleLive(rows: MatchRow[], live: LiveRow[]): boolean {
  const liveIds = new Set(live.map((row) => row.id));
  return rows.some((row) => row.is_live && !liveIds.has(row.id));
}

/** Поле есть в батче → заменить (в т. ч. null = очистить); поля нет → оставить как было. */
export function mergeLive(screen: MatchesScreen, live: LiveRow[]): MatchesScreen {
  if (live.length === 0) return screen;
  const byId = new Map(live.map((row) => [row.id, row]));
  let changed = false;
  const days = screen.days.map((day) => {
    let dayChanged = false;
    const matches = day.matches.map((row) => {
      const update = byId.get(row.id);
      if (!update) return row;
      dayChanged = true;
      return { ...row, ...update };
    });
    if (!dayChanged) return day;
    changed = true;
    return { ...day, matches };
  });
  return changed ? { ...screen, days } : screen;
}

/**
 * Батч отдаёт только ИДУЩИЕ матчи. Если строка у нас «живая», а в батче её нет — матч закончился
 * (или поставщик опустил флаг): локально это не выводим, а перезапрашиваем полотно целиком.
 */
export function hasStaleLive(screen: MatchesScreen, live: LiveRow[]): boolean {
  const liveIds = new Set(live.map((row) => row.id));
  return screen.days.some((day) => day.matches.some((row) => row.is_live && !liveIds.has(row.id)));
}

/** Смещение зрителя строго ±HH:MM (сервер молча превращает кривое значение в +00:00). */
export function timezoneOffset(date: Date = new Date()): string {
  const minutes = -date.getTimezoneOffset();
  const sign = minutes >= 0 ? '+' : '-';
  const abs = Math.abs(minutes);
  const hh = String(Math.floor(abs / 60)).padStart(2, '0');
  const mm = String(abs % 60).padStart(2, '0');
  return `${sign}${hh}:${mm}`;
}
